import { h, Component } from 'preact'
import Chats from '../../components/Chats'
import s from './Messenger.css'
import ChatLayout from '../../components/ChatLayout'
import tdlib, { TdEvent } from '../../utils/tdlib'
import { ConnectionState } from '../../types/auth'

interface iState {
  connectionState: ConnectionState
}

class Messenger extends Component<{}, iState> {
  state = {
    connectionState: ConnectionState.ready
  }

  componentDidMount (): void {
    tdlib.subscribe(
      'updateConnectionState',
      (event: TdEvent) => {
        this.setState({
          connectionState: event.state['@type']
        })
      }
    )
  }

  render () {
    const { connectionState } = this.state

    return (
      <div className={s.Messenger}>
        <Chats connectionState={connectionState}/>
        <ChatLayout/>
      </div>
    )
  }
}

export default Messenger
